// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "" + chunkId + ".05fa2015bfec778f78aa36167d5c4aad232ac771.chunk.bundle.js";
};